import { defineStore } from 'pinia'
import { filterAsyncRoutes } from '@/router'
import { store } from '../index'
import request from '@/libs/request'

export const usePermissionStore = defineStore('permission',{
	
	state:()=>({
		header:  [],
		auth:    [],
		routes:  [],
		status:  false,
		active:  0
	}),

    getters: {
		getSidebar:(state)=>{
			return state.header[state.active].children;
		}
    },

    actions: {
		getPurview(){
			return new Promise((resolve,reject)=>{
				request.get("purview/index").then(res=>{
					if(res.code){
						this.header = res.data.sidebar;
						this.auth   = res.data.auth;
						this.routes = filterAsyncRoutes(res.data.routes);
						resolve();
					}else{
						reject();
					}
				});
			});
		},
		getAuth(){
			return this.auth;
		},
		setActive(index){
			this.active = index;
		},
		getActive(){
			return this.active;
		},
		setStatus(value){
			this.status = value;
		},
		getStatus(){
			return this.status;
		}
    },
	// persist: true
	// persist: {
	// 	enabled: true,
	// 	key: 'permission',
	// 	storage: localStorage,
	// }
});

export const usePermissionStoreWithOut = () => {
  return usePermissionStore(store)
}